import { isLiftTicketCategory } from 'common/modules/skidata';
import { getTranslation, Languages } from 'common/modules/translations';
import { ById, Category, ProductApi } from 'common/types';
import categoryImagePlaceholder from 'common/assets/product-placeholder.png';

export interface CategoriesTableRow {
	id: string;
	name: string;
	description: string;
	image: string | undefined;
	productCount: number;
	orderIndex: number;
	canDelete: boolean;
}

export const categoryToCategoriesTableRow = (deps: {
	lang: Languages;
	productsByCategory: ById<ProductApi[]>;
}) => (category: Category): CategoriesTableRow => {
	const { lang, productsByCategory } = deps;
	return {
		id: category.id,
		name: getTranslation(category.name, lang),
		description: getTranslation(category.description, lang),
		image: category.imageUrl || categoryImagePlaceholder,
		productCount: productsByCategory[category.id]?.length ?? 0,
		orderIndex: category.orderIndex ?? 0,
		canDelete: !isLiftTicketCategory(category),
	};
};
